import { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { TranslationsContext } from '../../../context/TranslationsContext';

export const ProfileHelmet = () => {
  const { profileTranslations, profileLang } = useContext(TranslationsContext);

  return (
    <Helmet htmlAttributes={{ lang: profileLang, amp: undefined }}>
      <title>{profileTranslations?.head?.profilePage?.title}</title>
      <meta
        name="description"
        content={profileTranslations?.head?.profilePage?.description}
      />

      <meta property="og:url" content="https://www.mykin.in/" />
      <meta property="og:image" content="https://www.mykin.in/preview.png" />
      <meta property="og:image:width" content="663" />
      <meta property="og:image:height" content="649" />
      <meta
        property="og:title"
        content={profileTranslations?.head?.profilePage?.title}
      />
      <meta
        property="og:description"
        content={profileTranslations?.head?.profilePage?.ogDescription}
      />
      <meta name="twitter:image" content="https://www.mykin.in/preview.png" />
      <meta
        name="twitter:title"
        content={profileTranslations?.head?.profilePage?.title}
      />
      <meta
        name="twitter:description"
        content={profileTranslations?.head?.profilePage?.ogDescription}
      />
      <meta property="vk:url" content="https://www.mykin.in" />

      <meta property="vk:image" content="https://www.mykin.in/preview.png" />
      <meta
        property="vk:title"
        content={profileTranslations?.head?.profilePage?.title}
      />
      <meta
        property="vk:description"
        content={profileTranslations?.head?.profilePage?.ogDescription}
      />
    </Helmet>
  );
};
